const TaskerProfileSkeleton = () => {
  return (
    <>
      {/* Top Content Skeleton */}
      <div className="top-content flex lg:flex-row md:gap-[46px] gap-[30px] flex-col animate-pulse">
        {/* Profile Image Section Skeleton */}
        <div className="left-container min-w-[12vw] flex flex-col items-center">
          <div className="w-36 h-36 bg-gray-300 rounded-full "></div>
          <div className="flex mt-[34px] gap-[9px] justify-center items-center">
            <div className="w-40 h-4 bg-gray-300 rounded "></div>
          </div>
          <div className="flex justify-center items-center gap-[9px] mt-[8px]">
            <div className="w-32 h-4 bg-gray-300 rounded "></div>
          </div>
          <div className="mt-[8px] w-36 h-6 bg-gray-300 rounded "></div>
        </div>

        {/* Profile Details Section Skeleton */}
        <div className="right-container lg:max-w-[56vw] w-full flex flex-col lg:pt-2 gap-[24px]">
          {/* Name Skeleton */}
          <div className="w-56 h-8 bg-gray-300 rounded "></div>

          {/* About Me Skeleton */}
          <div className="flex flex-col gap-[8px] lg:mt-4">
            <div className="w-24 h-5 bg-gray-300 rounded "></div>
            <div className="w-full h-7 bg-gray-300 rounded "></div>
          </div>

          {/* Service Areas Skeleton */}
          <div className="flex flex-col gap-2">
            <div className="w-24 h-5 bg-gray-300 rounded "></div>
            <div className="w-full h-7 bg-gray-300 rounded "></div>
          </div>

          {/* Sub City Skeleton */}
          <div className="flex flex-col gap-[8px]">
            <div className="w-24 h-5 bg-gray-300 rounded "></div>
            <div className="w-full h-7 bg-gray-300 rounded "></div>
          </div>

          {/* Categories Skeleton */}
          <div className="flex flex-col gap-[8px]">
            <div className="w-24 h-5 bg-gray-300 rounded "></div>
            <div className="w-full h-7 bg-gray-300 rounded "></div>
          </div>

          {/* Skills Skeleton */}
          <div className="flex flex-col gap-[8px]">
            <div className="w-24 h-5 bg-gray-300 rounded "></div>
            <div className="w-full h-7 bg-gray-300 rounded "></div>
          </div>
        </div>
      </div>

      {/* Bottom Content Skeleton */}
      <div className="bottom-content mt-6 flex justify-end animate-pulse">
        <div className="w-32 h-10 bg-gray-300 rounded "></div>
      </div>
    </>
  );
};

export default TaskerProfileSkeleton;
